import { Injectable } from '@angular/core';
import { AlertController, AlertOptions } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { IPedido } from '@mobile/models/pedido/pedido.model';
import { StatusPedidoEnum } from '@mobile/models/status-pedido.enum';
import { PedidosFirebaseService } from '../firebase/pedidos-firebase.service';
import { BehaviorSubject, Unsubscribable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {

  private _pedido = new BehaviorSubject(null);
  private _pedidoEfetuado = new BehaviorSubject<string[]>([]);
  private _pedidosNotificados = new BehaviorSubject<{idPedido: string, statusNotificados: any}[]>([]);

  private _watchPedidos: { [key: string]: Unsubscribable } = {};

  constructor(
    private alertCtrl: AlertController,
    private storage: Storage,
    private pedidosFirebase: PedidosFirebaseService,
  ) {
    this.ngOnInit();
  }

  async ngOnInit(): Promise<void> {
    const pedido = await this.storage.get('pedido');
    const pedidoEfetuado = await this.storage.get('pedidoEfetuado');
    const pedidosNotificados = await this.storage.get('pedidosNotificados') ?? [];

    this._pedido.next(pedido);
    this._pedidoEfetuado.next(pedidoEfetuado);
    this._pedidosNotificados.next(pedidosNotificados);


    this.getPedidoEfetuado().subscribe((pedidoEfetuado: string[]) => {

      (pedidoEfetuado || [])
        .filter(key => Object.keys(this._watchPedidos).indexOf(key))
        .forEach(idPedido => {
          this._watchPedidos[idPedido] = this.pedidosFirebase.watchPedido(idPedido).subscribe(
            (data: any) => {
              const pedidoData = data as IPedido;

             const pedidosNotificados = this._pedidosNotificados.value;
             const statusNaoNotificado = pedidosNotificados.some(n => n.idPedido === pedidoData.id && (n.statusNotificados ?? []).indexOf(pedidoData.status) >= 0 )
              if(statusNaoNotificado) {
                this.changePedido(pedidoData);
              }

              // Remove apenas pedidos ENTREGUES da lista de acompanhamento
              // Pedidos CANCELADOS permanecem para o usuário ver o motivo
              if (pedidoData.status == StatusPedidoEnum.ENTREGUE) {
                this._watchPedidos[pedidoData.id] && this._watchPedidos[pedidoData.id].unsubscribe();

                let pedidos = this._pedidoEfetuado.value;
                pedidos = pedidos.filter(p => p !== pedidoData.id);
                this.setPedidoEfetuado(pedidos);
              }

              // Pedidos cancelados continuam sendo observados para atualizações
              // mas podem ser removidos manualmente pelo usuário
            }
          );
        })


    })





  }

  async changePedido(pedido: IPedido) {

    const opts: AlertOptions = {
      header: `Pedido #${pedido.id}`,
      buttons: ['ok']
    };

    switch (pedido.status) {
      case StatusPedidoEnum.PREPARO:
        opts.message = 'Seu pedido foi aprovado e esta em Preparo!';
        break;
      case StatusPedidoEnum.SAIU_PARA_ENTREGA:
        opts.message = `O Motoboy ${pedido.entregador} já está levando seu pedido!`;
        break;
      case StatusPedidoEnum.ENTREGUE:
        opts.message = `Seu pedido foi entregue com sucesso!`;
        break;
      case StatusPedidoEnum.CANCELADO:
        opts.message = pedido.motivo_cancelamento
          ? `Seu pedido foi cancelado. Motivo: ${pedido.motivo_cancelamento}`
          : `Seu pedido foi cancelado, para mais informações entre em contato!`;
        break;

      case StatusPedidoEnum.RETIRAR_NA_LOJA:
        opts.message = 'Seu pedido já pode ser retirado na loja!';
        break;

      default:
        break;
    }

    if (opts.message) {
      const alert = await this.alertCtrl.create(opts);
      alert.present();
      await this.updatePedidosNotificados(pedido);
    }
  }

  setPedido(pedido: any) {
    this.storage.set('pedido', pedido);
    this._pedido.next(pedido);
  }

  getPedido() {
    return this._pedido.asObservable();
  }

  removePedido() {
    this.storage.remove('pedido');
    this._pedido.next(null);
  }

  setPedidoEfetuado(pedido: string[]) {
    this.storage.set('pedidoEfetuado', pedido);
    this._pedidoEfetuado.next(pedido);
  }

  getPedidoEfetuado() {
    return this._pedidoEfetuado.asObservable();
  }

  removePedidoEfetuado() {
    this.storage.remove('pedidoEfetuado');
    this._pedidoEfetuado.next([]);
  }

  set pedidosNotificados(pedidos: { idPedido: string; statusNotificados: any; }[]) {
    this.storage.set('pedidosNotificados', pedidos);
    this._pedidosNotificados.next(pedidos);
  }

  async setNovoPedidosNotificados(pedido: { idPedido: string; statusNotificados: any; }) {
    const pedidosNotificados: { idPedido: string; statusNotificados: any; }[] = (await this.storage.get('pedidosNotificados')) ?? [];
    pedidosNotificados.push(pedido);
    this.pedidosNotificados = pedidosNotificados;
  }

  async updatePedidosNotificados(pedido: { id: string; status: any; }) {
    const pedidosNotificados: { idPedido: string; statusNotificados: any; }[] = (await this.storage.get('pedidosNotificados')) ?? [];
    const pedigoNotificado = pedidosNotificados.find(notificados => notificados.idPedido = pedido.id);

    // console.log('updatePedidosNotificados pedigoNotificado', pedigoNotificado)

    if (pedigoNotificado) {
      pedigoNotificado.statusNotificados.push(pedido.status);
      this.pedidosNotificados = pedidosNotificados;
    } else {
      this.setNovoPedidosNotificados({
        idPedido: pedido.id,
        statusNotificados: pedido.status,
      });
    }

  }
}
